"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../vendor/fontawesome/css/all.min.css");
